import { ExpiryDate } from './PaymentDetails';

enum PaymentFrequency {
    Monthly = 0,
    Quarterly = 1,
    Biannually = 2,
    Annually = 3,
    Once = 4
  }

interface IDebitCardDetails {
    kind: 'directdebit';
    accountHolderName: string;
    accountNumber: string;
    sortCode: string;
    paymentDay: string;
    paymentFrequency: PaymentFrequency;
    bankName: string;
    branchName: string;
    startDonationFrom: ExpiryDate;
}

const DefaultIDebitCardDetails: IDebitCardDetails = {
  kind: 'directdebit',
  accountHolderName: '',
  accountNumber: '',
  sortCode: '',
  paymentDay: '',
  paymentFrequency: PaymentFrequency.Monthly,
  bankName: '',
  branchName: '',
  startDonationFrom: { month: '', year: '' }
};

export { IDebitCardDetails, DefaultIDebitCardDetails };


// WEBPACK FOOTER //
// ./src/Types/Payments/IDebitCardDetails.ts